// extracted by css-extract-rspack-plugin
export default {"main":"main-jjPkYU","title":"title-LpSexE"};// extracted by css-extract-rspack-plugin
export default {"main":"main-jjPkYU","title":"title-LpSexE"};